/**
 * O prazo de uma pendência/compromisso escrito para o operador ler.
 *
 * Regra, preservada da versão que nasceu privada no web
 * (`use-panel-fixtures.ts`, `formatDuePT`): dentro das próximas 36h a resposta é
 * «amanhã» — o operador não precisa converter data em urgência; além disso, a
 * data curta.
 *
 * A janela é de 36h e não de 24h de propósito: um prazo de amanhã às 18:00
 * visto hoje às 09:00 está a 33h, e chamá-lo de «21/08/2026» esconderia que ele
 * é para o próximo turno de trabalho.
 *
 * ⚠️ LIMITAÇÃO DECLARADA — a data sai em UTC (`getUTCDate`), não no fuso do
 * operador. Para um produto brasileiro (UTC-3) isso desloca a data em um dia
 * nos prazos gravados entre 21:00 e 23:59 locais, que viram o dia seguinte em
 * UTC. O comportamento veio junto na promoção e está preservado byte a byte de
 * propósito: corrigir muda o que o web mostra hoje, e prazo é dado operacional
 * que merece veredito do TL, não conserto silencioso numa passada de higiene.
 * Corrigido aqui, corrige nos dois apps de uma vez — que é justamente o valor de
 * a régua ter passado a morar num lugar só.
 */
export function formatDeadlinePT(isoDate) {
    const due = new Date(isoDate);
    const diffHours = (due.getTime() - Date.now()) / (60 * 60 * 1000);
    if (diffHours > 0 && diffHours <= 36)
        return 'amanhã';
    const day = due.getUTCDate().toString().padStart(2, '0');
    const month = (due.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = due.getUTCFullYear().toString();
    return `${day}/${month}/${year}`;
}
//# sourceMappingURL=deadline-format.js.map